<template>
  <v-app>
    <router-view />
    <app-overlay v-if="showOverlay" />
  </v-app>
</template>

<script>
import AppOverlay from './components/Common/AppOverlay.vue';
export default {
  name: 'App',
  components: { AppOverlay },
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? 'dark' : 'light';
    },
    showOverlay() {
      return this.$store.state.showOverlay;
    },
  },
  mounted() {
    this.$vuetify.theme.dark = this.$store.state.setting.darkMode;
  },
};
</script>

<style>
/* @font-face {
  font-family: 'FontAwesome';
  src: url('./assets/font/fontawesome-webfont.ttf?v=4.7.0') format('truetype');
  src: url('./assets/font/fontawesome-webfont.eot?v=4.7.0');
  src: url('./assets/font/fontawesome-webfont.eot?#iefix&v=4.7.0') format('embedded-opentype'), url('./assets/font/fontawesome-webfont.woff?v=4.7.0') format('woff'), url('./assets/font/fontawesome-webfont.svg#fontawesomeregular?v=4.7.0') format('svg');
  font-weight: normal;
  font-style: normal;
} */

@import './assets/css/font-awesome.css';
@import './assets/css/appStyle.css';
</style>
